import { render, staticRenderFns } from "./Healthcare.vue?vue&type=template&id=13427949"
import script from "./Healthcare.vue?vue&type=script&lang=js"
export * from "./Healthcare.vue?vue&type=script&lang=js"
import style0 from "./Healthcare.vue?vue&type=style&index=0&id=13427949&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports